/* I am a webpack entry! */

import Vue from 'vue';
import App from './App.vue';
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
import commonObj from 'commonObj';
Vue.prototype.commonObj = commonObj;

Vue.prototype.callApp = function(url, mask, ckey) {
  const ua = navigator.userAgent.toLowerCase();
  const iosversion = ua.match(/OS [0-9]+_\d[_\d]* like Mac OS X/i);
  const wxversion = ua.match(/micromessenger\/([\d\.]+)/i);
  const wxversionArr = (wxversion && wxversion[1].split('.')) || [];
  const isWechat705 = (wxversionArr[0] >= 7 && wxversionArr[1] >= 0 && wxversionArr[2] >= 5);
  const isWeChat = /micromessenger/.test(ua);
  const isWeibo = /weibo/.test(ua);
  const isDingtalk = /dingtalk/.test(ua);
  const isQQ = /qq\//.test(ua);


  if (ua.indexOf('android') < 0) {
    //ios9-和微信705以下或者微博引导浏览器打开，其他使用universal link跳转
    if ((iosversion && iosversion.length > 0 && parseInt(iosversion[0].split(' ')[1]) < 9 && isWeChat && !isWechat705) || isWeibo || isQQ) {
      // 引导浏览器打开
      mask.show();
    } else {
      window.location.href = 'https://changbaapp.com/schema?url=' + encodeURIComponent(url) + '&channel=changbah5&report=1&h5_version=3.0.0';
    }
  } else {
    //安卓
    if (isWeChat) {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.changba&ckey=' + ckey + '&android_scheme=' + encodeURIComponent(url);
    }
    else if (isWeibo || isDingtalk) {
      // 引导浏览器打开
      mask.show();
    }
    else {
      window.location.href = url
      setTimeout(function() {
        const hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
        if (typeof hidden == "undefined" || hidden == false) {
          //应用宝下载地址
          window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.changba&ckey=' + ckey + '&android_scheme=' + encodeURIComponent(url);
        }
      }, 2500);
    }
  }
};

// 需要图片延迟加载请取消注释 lazysizes
// import 'lazysizes';

// 需要消除点击延迟请取消注释 fastclick
// import FastClick from 'fastclick';
// FastClick.attach(document.body);

// 一些 njwap 项目需要的初始化操作
import '@module/helper/init';

import '@cdn_css/index.scss';

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount('#app');
